import {
  getCheckoutCoownersData,
  getQuotation,
} from 'app/services/businessFunctionHelpers';
import { setBirthdateAndGenderByPesel } from 'app/services/businessFunctions/helpers/setBirthdateAndGenderByPesel';
import { validateCheckoutPesel } from 'app/services/pesel.service/validateCheckoutPesel';
import { QuotationService } from 'app/services/quotation.service';
import {
  FieldsEnum,
  FormsEnum,
  ModelPathEnum,
  PersonType,
} from 'app/shared/enums';

const secondCoownerDetails = {
  checkoutCoowners2PeselChange() {
    const { peselCheckoutForm: pesel } = getCheckoutCoownersData()[2];
    const isPeselCorrect = validateCheckoutPesel(PersonType.Coowner2);

    if (!isPeselCorrect) {
      return;
    }

    const { id } = getQuotation();
    QuotationService.update(id, ModelPathEnum.Coowners2PeselNumber, pesel);

    setBirthdateAndGenderByPesel(
      false,
      parseInt(pesel),
      FormsEnum.CheckoutForm,
      FieldsEnum.Coowners2BirthDate,
      FieldsEnum.Coowners2Gender
    );
  },
};

export default secondCoownerDetails;
